import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardActions, CardHeader, IconButton, Button, Menu, MenuItem, Modal, Box, Divider, FormControl, Select, InputLabel, TextField, Typography, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
// import Neighbourhood from '../neighbourhood/Neighbourhood';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import debounce from 'lodash.debounce';


const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Outgoing-waste' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    bag_distribution_group_id: string;
    pageSize: number;
    anchorEl: any;
    filter: any;
    pickup_status: any;
    groupPickups: any;
    showLoader: boolean;
    rowCount: any;
    selected_pod: any;
    /**Add waste by Vehicle Form Data */
}

class GroupBagDistribution extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            bag_distribution_group_id: this.props.match.params.id,
            pageSize: 20,
            anchorEl: null,
            filter: '',
            pickup_status: '',
            groupPickups: [],
            showLoader: false,
            rowCount: 0,
            selected_pod: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        console.log("props", this.props);
        this.fetchGroupPickups();
        document.addEventListener("copy", this.handleClipboardCopy);
    }


    public handleClipboardCopy = (event: ClipboardEvent) => {
        event.preventDefault();
      
        const selection = window.getSelection();
        if (!selection) return;
      
        // Extract selected text
        const selectedText = selection.toString().trim();
        console.log(selectedText);
      
        // If there's no selection, do nothing
        if (!selectedText) return;
      
        // Split the text into lines
        const lines = selectedText.split("\n").map(line => line.trim());
      
        // Group lines into records of 7 fields each
        const formattedText = [];
        for (let i = 0; i < lines.length; i += 9) {
          const record = lines.slice(i, i + 9).join("\t"); // Join 7 fields with tabs
          formattedText.push(record); // Add the formatted record to the array
        }
      
        // Join the records with new lines to keep each record on its own row
        const finalFormattedText = formattedText.join("\n");
      
        // Copy to clipboard
        event.clipboardData?.setData("text/plain", finalFormattedText);
    };

    public fetchGroupPickups(page: number = 0, limit: number = this.state.pageSize) {
        this.setState({ showLoader: true });
        let body = {
            "bag_distribution_group_id": this.state.bag_distribution_group_id,
            "filter": this.state.filter,
            "hierarchies": this.props.user.selectedHierarchyIds,
            "limit": limit,
            "page": page + 1,
            "pickup_type": "normal",
        }
        axios.post('filterDistributions', body, { headers: { "Content-Type": "application/json" } }).then((response: any) => {
            if (response.data.success) {
                this.setState({ showLoader: false, rowCount: response.data.data.total });
                let data = response.data.data.data;
                let groupPickupData: any = []
                data.map((el: any) => {
                groupPickupData.push({
                        "id": el.id,
                        "distribution_date": el.distribution_date,
                        "name": el.cust_name,
                        "mobile": el.user.phone,
                        "house_no": el.cust_hno,
                        "agent": el.agent_name,
                        "status": el.status,
                        "distribution_type": el.distribution_type,
                        "rescheduled_to": el.rescheduled_to,
                        "community_name": el.community.name,
                        "bag_count": el.bags_count,
                    })
                })
                this.setState({ groupPickups: groupPickupData });
            } else {
                this.setState({ showLoader: false });
                toast.error(response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                let errors = response.data.errors;
                for (var error in errors) {
                    toast.error(errors[error][0], {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                }
            }
        }).catch((error) => {
            this.setState({ showLoader: false });
            toast.error(error.response.data.msg, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });
    }

    handleSearch = debounce((page: number = 0, limit: number = this.state.pageSize) => {
        this.fetchGroupPickups(page, limit);
    }, 800);

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;


        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 120,
                renderCell: (params: GridCellParams) => (
                    <Link to={`/operations/bag-distribution/batches/bag-details/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.id}<OpenInNewOutlinedIcon sx={{ verticalAlign: "middle" }} /></Link>
                )
            },
            {
                headerName: "Date",
                field: "distribution_date",
                width: 180,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{cursor:'pointer'}} component='span'>{params.row.distribution_date}</Typography>
                )
            },
            {
                headerName: "Name",
                field: "name",
                width: 150
            },
            {
                headerName: "Mobile",
                field: "mobile",
                width: 120
            },
            {
                headerName: "House No.",
                field: "house_no",
                width: 100
            },
            {
                headerName: "Community",
                field: "community_name",
                width: 120
            },
            {
                headerName: "Agent",
                field: "agent",
                width: 120,
            },
            {
                headerName: "Status",
                field: "status",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{cursor:'pointer'}} sx={{ textTransform: 'capitalize' }} className={(params.row.status == 'pending') ? 'statusTextError' : 'statusTextSuccess'} component='span'>{params.row.status}</Typography>
                )
            },
            {
                headerName: t("Distribution Type"),
                field: "distribution_type",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Typography style={{cursor:'pointer'}} sx={{ textTransform: 'capitalize' }} component='span'>{params.row.distribution_type || '-'}</Typography>
                )
            },
            {
                headerName: "Barcodes",
                field: "bag_count",
                width: 200
            },

        ];

        const generateFileName = ((type: string, name: string) => {
            let typeTitles: any = {
                'club-house': "Club House (POD)",
                'individual-hh': "Individual HH (POD)"
            }
            return typeTitles[type] + '.pdf';
        })

        // const printPOD = (() => {
        //     this.setState({ showLoader: true });
        //     axios.get('bag/print-pod/' + this.state.bag_distribution_group_id + '/' + this.state.selected_pod, {
        //         responseType: 'blob',
        //     }).then((response: any) => {
        //         this.setState({ showLoader: false });
        //         let fileName = response.headers["x-filename"] || generateFileName(this.state.selected_pod, 'Hill County');
        //         const blob = new Blob([response.data], { type: response.headers['content-type'] });

        //         const link = document.createElement('a');
        //         link.href = window.URL.createObjectURL(blob);
        //         link.download = fileName;

        //         document.body.appendChild(link);
        //         link.click();

        //         document.body.removeChild(link);
        //     }).catch((error) => {
        //         this.setState({ showLoader: false });
        //         console.log("error logs here", error);
        //         toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
        //             position: "top-right",
        //             autoClose: false,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: false,
        //             draggable: true,
        //             progress: undefined,
        //             theme: "colored"
        //         });
        //     });
        // });
        const printPOD = (() => {
            this.setState({ showLoader: true });
            axios.get('bag/print-pod/' + this.state.bag_distribution_group_id + '/' + this.state.selected_pod, {
              responseType: 'blob',
            }).then((response: any) => {
              this.setState({ showLoader: false });
              const blob = new Blob([response.data], { type: response.headers['content-type'] });
              const url = window.URL.createObjectURL(blob);
              window.open(url, '_blank');
              setTimeout(() => {
                window.URL.revokeObjectURL(url);
              }, 100);
            }).catch((error) => {
              this.setState({ showLoader: false });
              console.log("error logs here", error);
              toast.error(((error.response?.data?.message) ? error.response.data.message : "Something went wrong"), {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored"
              });
            });
          });
         const downloadPOD = (() => {
            this.setState({ showLoader: true });
            axios.get('bag/download-pod/' + this.state.bag_distribution_group_id).then((response: any) => {
                this.setState({ showLoader: false });
                let fileName = response.headers["x-filename"] || "POD.csv";
                const blob = new Blob([response.data], { type: response.headers['content-type'] });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;

                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
            }).catch((error) => {
                this.setState({ showLoader: false });
                console.log("error logs here", error);
                toast.error(((error.response.data.message) ? error.response.data.message : "Something went wrong"), {
                    position: "top-right",
                    autoClose: false,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        })

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card style={{ height: 600 }}>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={8} xs={8}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Community Group Bag Distribution")}</Typography>
                                        </Grid>
                                        {/* <Grid item md={4} xs={2}>
                                            <Button variant='contained' sx={{ outline: 'none !important'}} >Print POD</Button>
                                            <Button variant='contained' sx={{ outline: 'none !important', marginLeft: '20px'}} >Download POD</Button>
                                        </Grid> */}
                                    </Grid>
                                }
                                className="text-left"
                            />
                            <CardActions>
                                <Grid container spacing={2}>
                                    <Grid item md={2} xs={12}>
                                        <FormControl fullWidth={true} size="small">
                                            <TextField
                                                id="filter-input"
                                                label={t("Search")}
                                                name="filter"
                                                value={this.state.filter}
                                                onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.handleSearch())}
                                                fullWidth={true}
                                                size="small"
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true} size="small">
                                            <InputLabel id="route-type-label">{t("Pickup Status")}</InputLabel>
                                            <Select
                                                labelId="route-type-label"
                                                value={this.state.pickup_status}
                                                onChange={(e: any) => this.setState({ pickup_status: e.target.value }, () => this.fetchGroupPickups())}
                                                displayEmpty
                                                label={t("Pickup Status")}
                                            >
                                                <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                <MenuItem key={'Collected'} value={'collected'}>{t("Collected")}</MenuItem>
                                                <MenuItem key={'Pending'} value={'pending'}>{t("Pending")}</MenuItem>
                                                <MenuItem key={'Complete'} value={'complete'}>{t("Complete")}</MenuItem>
                                                <MenuItem key={'Cancelled'} value={'cancelled'}>{t("Cancelled")}</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true} size="small">
                                            <InputLabel id="route-type-label">{t("Select POD")}</InputLabel>
                                            <Select
                                                labelId="route-type-label"
                                                value={this.state.selected_pod}
                                                onChange={(e: any) => this.setState({ selected_pod: e.target.value }, () => this.fetchGroupPickups())}
                                                displayEmpty
                                                label={t("Select POD")}
                                            >
                                                <MenuItem key={'club-house'} value={'club-house'}>{t("Club House POD")}</MenuItem>
                                                <MenuItem key={'individual-hh'} value={'individual-hh'}>{t("Individual HH POD")}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <Button variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.selected_pod} onClick={() => printPOD()}>Print POD</Button>
                                        <Button variant='contained' sx={{ outline: 'none !important', marginLeft: '20px' }} onClick={() => downloadPOD()} >Download POD</Button>
                                    </Grid>
                                </Grid>
                            </CardActions>
                            <CardContent>
                                <DataGrid
                                    aria-label="Outgoing Waste List"
                                    columns={columns}
                                    rows={this.state.groupPickups}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchGroupPickups(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchGroupPickups(0, newPageSize) }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    disableVirtualization
                                    // autoHeight={true}
                                    style={{ height: 400 }}
                                    components={{
                                        // MoreActionsIcon: EditOutlined,
                                        // Toolbar: CustomToolbar
                                    }}
                                    onRowClick={(params: GridRowParams) => {
                                        this.props.history.push('/operations/bag-distribution/batches/bag-details/' + params.id)
                                        // window.open(`/operations/batch-pickups/group-pickups/pickup-details/${params.id}`, '_blank', 'noreferrer');
                                    }}
                                    // componentsProps={{ toolbar: { csvOptions: { fileName: 'Tickets-list' } } }}
                                    paginationMode="server"
                                    className="clickableList"
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(GroupBagDistribution))
